<template>
    <div class="finance_widget">
        <template v-if="widgetData && widgetData.results.length" >
            <component :settings="settings" :is="'VuePerfectScrollbar'" :key="$vs.rtl" class="widget_scroll">
                <div class="collapse_wrapper">
                    <vs-collapse>
                        <vs-collapse-item v-for="(item, index) in widgetData.results" :key="index">
                            <div slot="header" class="text-base font-medium">
                                {{item.contract_type_data.name}}
                            </div>
                            <div>
                                <div class="mb-2">
                                    <div class="text-sm font-light">{{$t('agreement_date')}}:</div>
                                    <div class="val">{{$moment(item.contract_date).format('LL')}}</div>
                                </div>
                                <div class="mb-2">
                                    <div class="text-sm font-light" >{{ item.discount_type === null ? $t('total_amount') : $t('total_amount_disc')}}:</div>
                                    <div class="price val" v-html="priceReplace(item.total_payment_with_privilege)"></div>
                                </div>
                                <div class="mb-1 flex">
                                    <vs-button
                                        @click="getGraph(item)"
                                        color="primary"
                                        class="pl-3 pr-3 mr-1"
                                        icon-pack="feather"
                                        icon="icon-calendar"
                                        type="border"
                                        size="small">
                                            {{$t('schedule_widget')}}
                                    </vs-button>
                                    <vs-button
                                        @click="getHistory(item)"
                                        color="dark"
                                        type="border"
                                        class="pl-3 pr-3 mr-1"
                                        icon-pack="feather"
                                        icon="icon-list"
                                        size="small">
                                            {{$t('history')}}
                                    </vs-button>
                                    <vs-button
                                     v-if="finaces_pay&&use_acquiring.use_acquiring"
                                        @click="openPayPopup(item)"
                                        class="pl-3 pr-3"
                                        color="success"
                                        icon-pack="feather"
                                        icon="icon-credit-card"
                                        size="small">
                                            {{$t('pay')}}
                                    </vs-button>
                                </div>
                            </div>
                        </vs-collapse-item>
                    </vs-collapse>
                </div>
            </component>
        </template>

        <vs-alert :style="vs_alert_style" active="true" v-if="emptyMessage">
            {{$t('no_data_text')}}
        </vs-alert>

        <!-- Модалка с графиком -->
        <GraphPopup />

        <!-- Модалка с историей -->
        <HistoryPopup />

        <!-- Модалка с вводом суммы оплаты -->
        <PayPopup />

        <!-- Модалка с вводом истории оплаты -->
        <PayHistory />
    </div>
</template>

<script>
import axios from '@/configs/Axios'
import finance from '@/store/modules/finance.js'
import { price } from '@/pages/Home/MyFinances/config'
import GraphPopup from '@/pages/Home/MyFinances/components/GraphPopup'
import HistoryPopup from '@/pages/Home/MyFinances/components/HistoryPopup'
import PayPopup from '@/pages/Home/MyFinances/components/PayPopup'
import PayHistory from '@/pages/Home/MyFinances/components/PayHistory'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'
export default {
    props: {
        element: Object,
        vs_alert_style: Object,
    },
    data () {
        return {
            emptyMessage: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            widgetSetting: {
                api: '/finance/contracts/?page=1',
                uid: this.element.uid
            },
            use_acquiring:{}
        }
    },
    components: {
        VuePerfectScrollbar,
        GraphPopup,
        HistoryPopup,
        PayPopup,
        PayHistory
    },
    computed: {
        widgetData() {
            return this.$store.state.desktop.widgetData[this.widgetSetting.uid]
        },
        ...mapGetters({
            user: "user/STATE"
        }),
        finaces_pay(){
            return this.user.finances_pay
        },
    },
    async created() {
        // Регистрируем стор
        if(!this.$store.hasModule('finance'))
            this.$store.registerModule('finance', finance)

        this.getWidgetData()
        await axios.get('finance/use_acquiring/').then(res => {this.use_acquiring = res.data})
    },
    methods: {
        async getHistory(contract) {
            // Получить список истории оплаты
            try {
                this.$vs.loading({
                    scale: 0.6
                })
                const res = await this.$store.dispatch('finance/getHistoryList', {uid: contract.uid})
                if(res && res.results.length) {
                    this.$store.commit('finance/SET_HISTORY_POPUP', true)
                    this.$store.commit('finance/SET_POPUP_CONTRACT', contract)
                } else {
                    this.$vs.notify({
                        text: this.$t('no_data_text'),
                        color: 'warning'
                    })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger',
                })
            } finally {
                this.$vs.loading.close()
            }
        },
        async getGraph(contract) {
            // Получить список графика оплаты
            try {
                this.$vs.loading({
                    scale: 0.6
                })
                const res = await this.$store.dispatch('finance/getGraphList', {uid: contract.uid})
                if(res && res.results.length) {
                    this.$store.commit('finance/SET_GRAPH_POPUP', true)
                    this.$store.commit('finance/SET_POPUP_CONTRACT', contract)

                    const popupContent = document.querySelector('.graph_popup .vs-popup--content')
                    if(popupContent) {
                        popupContent.scrollTop = 0
                    }
                } else {
                    this.$vs.notify({
                        text: this.$t('no_data_text'),
                        color: 'warning'
                    })
                }
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger',
                })
            } finally {
                this.$vs.loading.close()
            }
        },
        openPayPopup(item) {
            // Открыть попап оплаты
            this.$store.commit('finance/SET_PAY_DATA', item)
        },
        priceReplace(sum, color) {
            return price(sum, color)
        },
        async getWidgetData() {
            try {
                const res = await this.$store.dispatch('desktop/getWidgetData', this.widgetSetting)
                if(res && !res.results.length)
                    this.emptyMessage = true
            } catch(e) {
                this.emptyMessage = true
            }
        }
    }
}
</script>

<style lang="scss">
.finance_widget{
    .vs-collapse-item--header{
        padding: 0.3rem;
    }
    .con-content--item{
        padding: 0.3rem!important;
    }
    .open-item{
        .vs-collapse-item--header{
            color: rgba(var(--vs-primary), 1) !important;
        }
    }
    .icon-header{
        color: rgba(var(--vs-primary), 1) !important;
    }
    .vs-collapse-item{
        border-color: rgba(var(--vs-primary), 1) !important;
    }
}
</style>

<style lang="scss" scoped>
.collapse_wrapper{
    margin: 0 -10px;
}
</style>
